module.exports = __webpack_public_path__ + "img/aliens-color.683128dd.png";